if (!customElements.get('free-gift-removals')) {
  class FreeGiftRemovals extends HTMLElement {
    constructor() {
      
      super();

      this.cartDrawer = document.getElementById('cart-drawer');

      this.init();

    }

    init() {

      if (this.removals) {
        this.removeGifts();
      }

    }

    async removeGifts() {

      try {

        this.fetchRequestOpts = {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        };

        const updates = {};

        for (let i = 0; i < this.removals.length; i++) {
          const removal = this.removals[i];
          updates[removal.dataset.key] = 0;
        }

        this.fetchRequestOpts.body = JSON.stringify({ updates: updates });

        const response = await fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
        const data = await response.json();

        if (this.cartDrawer) {
          this.cartDrawer.refresh(true);
        }
        else {
          location.reload();
        }

      } catch (error) {

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));

      }
    }
      
    get removals() {
      return this.querySelectorAll('free-gift-remove');
    }

  }

  customElements.define('free-gift-removals', FreeGiftRemovals);
}

if (!customElements.get('free-gift-adds')) {
  class FreeGiftAdds extends HTMLElement {
    constructor() {
      
      super();
      this.cartDrawer = document.getElementById('cart-drawer');
      this.init();

    }

    init() {

      if (this.adds) {
        this.addGifts();
      }

    }

    async addGifts() {

      try {
        
        this.fetchRequestOpts = {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        };

        let postData = {
         'items': []
        };

        for (let i = 0; i < this.adds.length; i++) {

          const add = this.adds[i];
          const quantity = 1;
          
          let item = {};

          item.id = Number(add.dataset.variantId);
          item.quantity = quantity;
          
          item.properties = {};
          item.properties["Free Gift"] = add.dataset.giftTitle;
          item.properties["_Free Gift Number"] = add.dataset.giftIndex;
          item.properties["_Free Gift ID"] = add.dataset.giftId;

          postData.items.push(item)
          
        }
        
        this.fetchRequestOpts.body = JSON.stringify(postData);

        const response = await fetch(theme.routes.cartAdd, this.fetchRequestOpts);
        const data = await response.json();

        if (this.cartDrawer) {
          this.cartDrawer.refresh(true);
        }
        else {
          location.reload();
        }

      } catch (error) {

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));

      }
    }
      
    get adds() {
      return this.querySelectorAll('free-gift-add');
    }

  }

  customElements.define('free-gift-adds', FreeGiftAdds);
}